// src/store/index.ts
// Export all operations-related atoms

// Export all auth-related atoms
export {
  type AuthUser,
  authErrorAtom,
  authLoadingAtom, // deprecated
  authNetworkErrorAtom,
  authUserAtom,
  initializeAuthAtom,
  isAuthenticatedAtom, // deprecated
  loginAtom,
  logoutAtom,
  retryAuthInitializationAtom,
  updateProfileAtom,
} from "./auth";
// Export all CRUD operation atoms
export {
  createIrrigationPlanAtom,
  createIrrigationPlanSectorMirrorAtom,
  createIrrigationPlanStepAtom,
  createIrrigationPlanStepTankAtom,
  createMeshDeviceMappingAtom,
  createProjectAtom,
  createProjectTankAtom,
  createPropertyAtom,
  createPropertyDeviceAtom,
  createPropertyDeviceSensorAssignmentAtom,
  createReservoirAtom,
  createSectorAtom,
  createSectorCropAtom,
  createTankAtom,
  createWaterPumpAtom,
  deleteIrrigationPlanSectorMirrorAtom,
  deleteIrrigationPlanStepAtom,
  deleteIrrigationPlanStepTankAtom,
  deleteMeshDeviceMappingAtom,
  deleteProjectTankAtom,
  deletePropertyDeviceSensorAssignmentAtom,
  deleteReservoirAtom,
  deleteSectorAtom,
  deleteSectorCropAtom,
  deleteTankAtom,
  swapIrrigationPlanStepsOrdersAtom,
  updateIrrigationPlanAtom,
  updateIrrigationPlanStepAtom,
  updateMeshDeviceMappingAtom,
  updateProjectAtom,
  updateProjectTankAtom,
  updatePropertyAtom,
  updatePropertyDeviceAtom,
  updatePropertyDeviceSensorAssignmentAtom,
  updateReservoirAtom,
  updateSectorAtom,
  updateSectorCropAtom,
  updateTankAtom,
  updateWaterPumpAtom,
} from "./crud";

// Export all data-related atoms
export {
  ACCOUNT_USER_TREE_DEBOUNCE_DELAY,
  accountUserTreeAtom,
  assignAccountAtom,
  availableAccountsAtom,
  clearPendingAccountUserTreeRequests,
  currentAccountAtom,
  currentIrrigationPlanStateByPlanIdAtom,
  // Current data/polling atoms
  currentIrrigationPlanStatesAtom,
  currentIrrigationPlanStatesByPropertyAtom,
  currentIrrigationPlanStatesErrorAtom,
  currentIrrigationPlanStatesLoadingAtom,
  currentLICPacketByIdAtom,
  currentLICPacketsAtom,
  currentLICPacketsByPropertyAtom,
  currentLICPacketsErrorAtom,
  currentLICPacketsLoadingAtom,
  cropTypesAtom,
  devicesAtom,
  devicesByIdAtom,
  fetchAccountsAtom,
  fetchCurrentIrrigationPlanStatesAtom,
  fetchCurrentLICPacketsAtom,
  fetchLatestLICEventsAtom,
  fetchLatestMeshDeviceEventsAtom,
  fetchLicStatesAtom,
  fetchReferenceDataAtom,
  irrigationPlanByIdAtom,
  plansByLicIdAtom,
  irrigationPlansAtom,
  irrigationPlansByProjectIdAtom,
  latestLICPacketByDeviceAndTypeAtom,
  licStateByDeviceIdAtom,
  licStatesAtom,
  licStatesByPropertyAtom,
  licStatesErrorAtom,
  licStatesLoadingAtom,
  licsWithRainGaugeAtom,
  nutrientsAtom,
  projectByIdAtom,
  projectsAtom,
  propertiesAtom,
  propertyByIdAtom,
  propertyDevicesAtom,
  projectTanksByProjectIdAtom,
  projectTanksByTankIdAtom,
  rainfallDataByPropertyAtom,
  refetchDataAtom,
  reservoirsAtom,
  reservoirsByIdAtom,
  sectorCropsBySectorIdAtom,
  selectedAccountUserIdAtom,
  selectedPropertyAtom,
  selectedPropertyIdAtom,
  stepTanksByStepIdAtom,
  tanksAtom,
  tanksByIdAtom,
  unassignAccountAtom,
  waterPumpsAtom,
  waterPumpsByIdAtom,
} from "./data";
export {
  addErrorOperationAtom,
  addLoadingOperationAtom,
  cleanupErrorsAtom,
  currentLoadingMessageAtom,
  displayErrorsAtom,
  displayLoadingAtom,
  type ErrorOperation,
  errorOperationsAtom,
  hasActiveLoadingAtom,
  isNetworkError,
  type LoadingOperation,
  loadingOperationsAtom,
  type OperationOptions,
  removeErrorOperationAtom,
  removeLoadingOperationAtom,
  withOperationHandlingAtom,
} from "./operations";

// Export all UI-related atoms
export {
  addToastAtom,
  appShell,
  removeAllToastsAtom,
  removeToastAtom,
  showErrorToastAtom,
  showInfoToastAtom,
  showSuccessToastAtom,
  showWarningToastAtom,
  type ToastData,
  type ToastPosition,
  toastsAtom,
} from "./ui";

// Helper hooks for common patterns
import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import {
  authUserAtom,
  isAuthenticatedAtom,
  loginAtom,
  logoutAtom,
  //   addToastAtom,
  refetchDataAtom,
  updateProfileAtom,
} from "./index";

// Custom hooks for common operations
export const useAuth = () => {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  const user = useAtomValue(authUserAtom);
  const login = useSetAtom(loginAtom);
  const logout = useSetAtom(logoutAtom);
  const updateProfile = useSetAtom(updateProfileAtom);

  return {
    isAuthenticated,
    user,
    login,
    logout,
    updateProfile,
  };
};

export const useDataRefresh = () => {
  const refetchData = useSetAtom(refetchDataAtom);

  const refreshData = useCallback(async () => {
    try {
      await refetchData();
    } catch (error) {
      console.error("Failed to refresh data:", error);
    }
  }, [refetchData]);

  return { refreshData };
};
